<template>
    <div v-if="asyncDataStatus_ready">

    <v-row justify="space-between">
      <v-col cols="6" md="3">
        <v-text-field
          v-if="this.categories.length"
          placeholder="Išči..."
          append-icon="mdi-search"
          v-model="filter"
          @keydown.esc="filter=''"
        ></v-text-field>
      </v-col>
      <v-col cols="auto">
        <v-btn
          color="#0F998E"
          class="white--text"
          @click="$router.push({name: 'MyCompanyCategoriesNew'})"
        >
          Nova skupina
          <v-icon right dark>mdi-plus</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row v-if="this.categories.length">
       <v-col>
        <v-simple-table fixed-header>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">
                  Skupine
                </th>

              </tr>
            </thead>
          </template>
        </v-simple-table>
      </v-col>
      <v-col
        v-for="item in filteredCategories"
        :key="item.id"
        cols="12"
        class="pt-0 pb-0 "
      >
        <TitleOnlyCard
          :style="{ 'border-left': `5px solid ${item.color}` }"
          :title="item.name"
          :category="item"
          @edit="$router.push({name: 'MyCompanyCategoriesEdit', params: {id: item.id}})"
          @delete="showDeleteCategoryModal = true; deleteCategory = item"
        />
      </v-col>
    </v-row>
    <v-row
      v-else
    >
      <v-col cols="12">
        <p class="text-center">
          Ni rezultatov iskanja. Za dodajanje nove skupine uporabite gumb desno zgoraj.
        </p>
      </v-col>
    </v-row>

    <ConfirmDialog
      title="Brisanje skupine"
      text="Ali ste prepričani, da želite izbrisati skupino? Podatki bodo trajno izbrisani."
      okBtnText="Briši"
      v-model="showDeleteCategoryModal"
      @confirmed="remove(deleteCategory)"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import asyncDataStatus from '@/mixins/asyncDataStatus'
import { siIncludes } from '@/utils/str'
import { loadItems, deleteItem } from '@/utils/crudFunctions'
import ConfirmDialog from '@/components/ConfirmDialog'
import TitleOnlyCard from '@/components/TitleOnlyCard'
import { objectToArray } from '@/utils/object'

export default {
  components: {
    ConfirmDialog,
    TitleOnlyCard
  },
  mixins: [
    asyncDataStatus
  ],
  data () {
    return {
      filter: '',
      showDeleteCategoryModal: false,
      deleteCategory: null
    }
  },
  computed: {
    categories () {
      return objectToArray(this.$store.state.categories.items)
    },
    filteredCategories () {
      return this.categories.filter(item => siIncludes({ haystack: `${item.name}`, needle: this.filter }))
    }
  },
  methods: {
    ...mapActions('categories', ['loadItems', 'deleteItem']),
    triggerDelete (item) {
      this.deleteCategory = item
      this.showDeleteCategoryModal = true
    },
    remove (item) {
      deleteItem(item, this)
    }
  },
  created () {
    if (!this.$store.state.businessUnits.currentBusinessUnit) {
      this.$notify({ type: 'error', text: 'Potrebna je vsaj ena aktivna poslovna enota' })
    } else {
      loadItems(this)
    }
  }
}
</script>
